module.exports = __webpack_public_path__ + "static/img/imager_10038 1.494f2f84.png";